import { Box, Container, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import diffMonth from '../../assets/images/diff.png';
import { ImageSearchOutlined, AddBusinessOutlined, CreditScoreOutlined } from '@mui/icons-material';
import { useInView } from '../../hooks/useInView';

const PRIMARY = '#8c7c0c';

const CARDS = [
    {
        Icon: ImageSearchOutlined,
        title: 'Find Your Perfect Home',
        desc: 'Browse verified listings and discover the ideal rental that suits your needs and lifestyle.',
    },
    {
        Icon: AddBusinessOutlined,
        title: 'Build a Payment Record',
        desc: 'Make timely rent payments to establish a solid financial reputation and unlock future benefits.',
    },
    {
        Icon: CreditScoreOutlined,
        title: 'Access Rent Credit',
        desc: 'Get financial support when needed — ensuring you never fall behind on rent payments.',
    },
];

const Tenant: FC = () => {
    const { ref, visible } = useInView();

    return (
        <Box
            component="section"
            id="tenant"
            ref={ref}
            sx={{ py: { xs: 8, md: 12 }, bgcolor: PRIMARY }}
        >
            <Container maxWidth="lg">
                {/* Main feature card */}
                <Box
                    className={`sg-reveal ${visible ? 'sg-visible' : ''}`}
                    sx={{
                        bgcolor: '#fff', borderRadius: 4, overflow: 'hidden', mb: 6,
                        boxShadow: '0 20px 60px rgba(0,0,0,.15)',
                    }}
                >
                    <Grid container alignItems="stretch">
                        <Grid item xs={12} md={5} sx={{ bgcolor: '#faf8ee', display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 4, md: 6 } }}>
                            <img
                                src={diffMonth}
                                alt="Rent credit illustration"
                                loading="lazy"
                                style={{ width: '100%', maxWidth: 340, objectFit: 'contain' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={7} sx={{ p: { xs: 4, md: 6 }, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Typography sx={{ display: 'inline-block', bgcolor: `${PRIMARY}12`, color: PRIMARY, px: 2, py: 0.5, borderRadius: 20, fontSize: 13, fontWeight: 600, mb: 2, alignSelf: 'flex-start' }}>
                                For Tenants
                            </Typography>
                            <Typography component="h2" sx={{ fontSize: { xs: 26, md: 38 }, fontWeight: 800, color: '#111827', lineHeight: 1.2, mb: 2 }}>
                                Pay Rent on Time,{' '}
                                <Box component="span" sx={{ color: PRIMARY }}>Even in Tough Months</Box>
                            </Typography>
                            <Typography sx={{ fontSize: 15.5, color: '#6b7280', lineHeight: 1.75, mb: 4 }}>
                                Build a strong rent payment history to unlock credit from our investor-backed liquidity pool — secure, transparent, and hassle-free.
                            </Typography>
                            <Box>
                                <a href="/auth?signup=true" className="sg-btn-primary">Get Started Free</a>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {/* Feature cards */}
                <Grid container spacing={3}>
                    {CARDS.map(({ Icon, title, desc }, i) => (
                        <Grid item xs={12} sm={4} key={title}>
                            <Box
                                className={`sg-reveal sg-card-lift ${visible ? 'sg-visible' : ''}`}
                                style={{ transitionDelay: `${i * 0.1 + 0.15}s` }}
                                sx={{
                                    p: 3.5,
                                    bgcolor: 'rgba(255,255,255,.1)',
                                    borderRadius: 3,
                                    border: '1px solid rgba(255,255,255,.2)',
                                    height: '100%',
                                }}
                            >
                                <Box sx={{ display: 'inline-flex', p: 1.5, bgcolor: 'rgba(255,255,255,.15)', borderRadius: 2, mb: 2 }}>
                                    <Icon sx={{ fontSize: 26, color: '#fff' }} />
                                </Box>
                                <Typography sx={{ fontWeight: 700, fontSize: 17, color: '#fff', mb: 1 }}>{title}</Typography>
                                <Typography sx={{ fontSize: 14.5, color: 'rgba(255,255,255,.75)', lineHeight: 1.65 }}>{desc}</Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Tenant;
